import { NotFound404 } from '@backrs_ui/common-ui';

export const NotFound404Page = () => {
  return <NotFound404 />;
};
